/* Scuffo storefront motion: reveal-on-scroll and the photo carousel arrows. */
(function () {
  var els = document.querySelectorAll('.sc-reveal');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {rootMargin: '0px 0px -8% 0px'});
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }
  document.querySelectorAll('[data-sc-carousel]').forEach(function (track) {
    var wrap = track.parentNode;
    var step = function (dir) { var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 24 : 300; track.scrollBy({left: dir * w, behavior: 'smooth'}); };
    var prev = wrap.querySelector('[data-sc-prev]'), next = wrap.querySelector('[data-sc-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });
})();
